/* targa-offerbar.js — evergreen countdown for the sticky top offer bar.
   Each visitor gets a personal 1-hour deadline stored in localStorage
   (targa_offer_end_v1). When it expires, it silently resets to a fresh hour
   (evergreen urgency — the offer never actually ends). Display capped at 59:59.
   Also measures the bar and publishes --announcement-bar-height so the theme's
   sticky header (top: calc(enabled * height)) slots itself right below the bar. */
(function () {
  var KEY = 'targa_offer_end_v1';
  var DURATION = 60 * 60 * 1000; // 1h per visitor

  function getEnd() {
    var t = 0;
    try { t = parseInt(localStorage.getItem(KEY) || '0', 10) || 0; } catch (e) {}
    var now = Date.now();
    if (t <= now || t - now > DURATION) {
      t = now + DURATION;
      try { localStorage.setItem(KEY, String(t)); } catch (e) {}
    }
    return t;
  }

  function fmt(s) {
    if (s > 3599) s = 3599;
    var m = Math.floor(s / 60), ss = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (ss < 10 ? '0' : '') + ss;
  }

  var end = 0;
  function tick() {
    var els = document.querySelectorAll('[data-offer-count]');
    if (!els.length) return;
    var now = Date.now();
    if (!end) end = getEnd();
    var s = Math.floor((end - now) / 1000);
    if (s <= 0) { end = getEnd(); s = Math.floor((end - now) / 1000); }
    var txt = fmt(Math.max(0, s));
    els.forEach(function (el) { if (el.textContent !== txt) el.textContent = txt; });
  }

  function measure() {
    var bar = document.querySelector('.targa-offerbar');
    if (bar && bar.offsetHeight) {
      document.documentElement.style.setProperty('--announcement-bar-height', Math.round(bar.offsetHeight) + 'px');
    }
  }

  /* On pages where the theme header is actually sticky (e.g. PDP; the homepage
     renders it relative for the transparent-hero mode), pin it right below the
     bar. Inline top only on sticky headers — a relative header would be shifted
     down by `top`, so those are left untouched. */
  function offsetHeader() {
    var sec = document.querySelector('.shopify-section-group-header-group');
    if (!sec) return;
    if (getComputedStyle(sec).position === 'sticky') {
      sec.style.top = 'calc(var(--sticky-announcement-bar-enabled, 0) * var(--announcement-bar-height, 0px))';
    }
  }

  function boot() {
    measure();
    offsetHeader();
    tick();
    if (!window.__targaOfferInt) window.__targaOfferInt = setInterval(tick, 1000);
  }

  boot();
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  window.addEventListener('resize', function () { measure(); offsetHeader(); });
  setTimeout(boot, 400); setTimeout(boot, 1200);
})();
